/* src/app/features/prestacao-informacoes/atualizacao-informacoes-risco/atualizacao-info-risco-listagem.component.scss */
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=atualizacao-info-risco-listagem.component.css.map */
